<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <!--    <svg-icon icon-class="cargoware-logo" style="width:180px;height:50px;" />-->
    <el-scrollbar wrap-class="scrollbar-wrapper" style="height:calc(100% - 50px)">
      <el-menu
        :default-active="activeMenuIndex"
        :default-openeds="[activeMenuIndex]"
        :collapse="isCollapse"
        :background-color="menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        :unique-opened="true"
        mode="vertical"
        @open="toggleSubMenu(true,$event)"
        @close="toggleSubMenu(false, $event)"
      >
        <sidebar-item v-for="(route,index) in curRouteMenus" :key="route.path + index" :item="route" :current-menu="currentMenu" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
    <div class="siderbar-arrow" :class="{arrowLeft: isCollapse}" @click="toggleSideBar">
      <i v-show="!isCollapse" class="el-icon-arrow-left" />
      <i v-show="isCollapse" class="el-icon-arrow-right" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      currentMenu: {}, // 当前操作的菜单，为了动态处理菜单
      curRouteMenus: []
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar',
      'isProd'
    ]),
    activeMenuIndex() {
      return (this.currentMenu && this.currentMenu.open && this.currentMenu.menuId + '') + ''
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    menuBg() {
      return this.$store.state.settings.isUIPersonalized ? '#A5EBFF' : variables.menuBg
    }
  },
  beforeCreate() {
    // todo 有时无效
    console.log('sideBar index')
    const url = location.href.split('?')[0]
    history.replaceState({}, '', url)
  },
  mounted() {
    window.addEventListener('resize', this.windowResize)
    this.refreshRouteList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize)
  },
  '$store.getters.currentOfficeId': {
    immediate: true,
    async handler() {
      this.refreshRouteList()
    }
  },
  methods: {
    toggleSubMenu(toOpen, menuId) {
      console.log('curRouteMenus=========', this.curRouteMenus)
      this.curRouteMenus.forEach(item => {
        if (Number(item.menuId) === Number(menuId)) {
          this.currentMenu = { menuId, open: toOpen }
        }
      })
    },
    toggleSideBar() {
      console.log('toggleSideBar')
      this.$store.dispatch('app/toggleSideBar')
    },
    windowResize() {
      const resize = this.$el.querySelector('.el-scrollbar__wrap')
      resize.style.marginRight = `-${resize.offsetWidth - resize.clientWidth}px`
    },
    // 根据投保参数判断显示货运险责任险还是恪保菜单
    async refreshRouteList() {
      await cache.load(cacheName.CONFIG)
      const list = this.permission_routes
      // if (Number(cache.config.get('isPlatformInsurance')) === 3) {
      //   for (const root of list) {
      //     this.removeNode(root, 'InsurancePolicy')
      //     this.removeNode(root, 'InsuranceBilling')
      //     this.removeNode(root, 'InsuranceInvoice')
      //   }
      // } else {
      //   for (const root of list) {
      //     this.removeNode(root, 'CargoInsurance')
      //     this.removeNode(root, 'LiabilityInsurance')
      //   }
      // }
      for (const root of list) {
        this.removeNode(root, 'InsurancePolicy')
        this.removeNode(root, 'InsuranceBilling')
        this.removeNode(root, 'InsuranceInvoice')
      }
      this.curRouteMenus = list
    },
    // 移除节点
    removeNode(tree, module) {
      if (tree.module === module) {
        return null
      }
      if (tree.children) {
        const childList = []
        for (const child of tree.children) {
          const returnChild = this.removeNode(child, module)
          if (returnChild) {
            childList.push(returnChild)
          }
        }
        tree.children = childList
      }
      return tree
    }
  }
}
</script>
<style lang="scss">
.siderbar-arrow {
  position: fixed;
    left: 199px;
    width: 9px;
    height: 55px;
    background: #252B3B;
    top: 50%;
    transform: translate(0px, -50%);
    border-radius: 0 3px 3px 0px;
    text-align: center;
    line-height: 55px;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 6px;
    }
}
.arrowLeft {
  // left:36px;
}
</style>

<!-- 中文样式 -->
<style lang="scss">
#app.zh {
  .siderbar-arrow {
    left: 199px;
  }
  .arrowLeft {
    left:36px;
  }
}
</style>

<!-- 英文样式 -->
<style lang="scss">
#app.en {
  .siderbar-arrow {
    left: 259px;
  }
  .arrowLeft {
    left:36px;
  }
}
</style>
